import React, { useMemo } from 'react';
import {
  Button,
  Link,
  makeStyles,
  Tooltip,
  Typography
} from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { colors } from 'src/constants';
import { PoweredBuildsPriceListData, ProductPriceListData } from 'src/types';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

interface TypographyPriceListProps {
  text?: string;
  subText?: string;
  color?: string;
  link?: string;
  fontSize?: number;
  branchIds?: number[];
  onCopy?: () => void;
  extraTextStyle?: React.CSSProperties;
  data?: ProductPriceListData & PoweredBuildsPriceListData;
}

const useStyles = makeStyles(
  {
    row: { flexDirection: 'row', display: 'flex' },
    text: {
      letterSpacing: 0.5,
      fontWeight: 600
    }
  },
  { index: 999 }
);

export const PriceList = ({
  text,
  subText,
  onCopy,
  link,
  color = colors.black,
  fontSize = 14,
  extraTextStyle,
  data
}: TypographyPriceListProps) => {
  const classes = useStyles();
  const customTextStyle = {
    color,
    fontSize,
    ...extraTextStyle
  };

  const isHiddenText = useMemo(() => {
    const isHiddenOnArrStr: string[] = [];

    if (data?.is_hidden_via_category) {
      isHiddenOnArrStr.push('category');
    }

    if (data?.is_hidden_via_product) {
      isHiddenOnArrStr.push('product');
    }

    if (data?.is_hidden_via_quotation) {
      isHiddenOnArrStr.push('quotation');
    }

    if (data?.is_hidden_via_category_to_quotation) {
      isHiddenOnArrStr.push('category to quotation');
    }

    if (!isHiddenOnArrStr?.length) {
      return '';
    }

    return `Hidden via ${isHiddenOnArrStr.join(', ')}`;
  }, [data]);

  return (
    <div className={classes.row}>
      {isHiddenText ? (
        <Tooltip title={isHiddenText} placement="top">
          <VisibilityOffIcon />
        </Tooltip>
      ) : null}

      {onCopy ? (
        <Button
          style={{ padding: 0, margin: 0 }}
          startIcon={<FileCopyIcon />}
          onClick={onCopy}
        />
      ) : null}

      {link ? (
        <Link href={link} target="_blank">
          <Typography className={classes.text} style={customTextStyle}>
            {text}
          </Typography>
          {subText && (
            <Typography className={classes.text} style={customTextStyle}>
              {subText}
            </Typography>
          )}
        </Link>
      ) : (
        <Typography className={classes.text} style={customTextStyle}>
          {text}
        </Typography>
      )}
    </div>
  );
};

export const TypographyPriceList = React.memo(PriceList);
